import * as dat from 'dat.gui'; 

export function initGUI(camera){
    let gui = new dat.GUI(); 
    gui.open();//默认打开面版
    gui.add(camera.position, 'x')
        .name('摄像头x轴') 
        .min(-6).max(6).step(0.02);
    gui.add(camera.position, 'y')
        .name('摄像头y轴') 
        .min(-6).max(6).step(0.02);
    gui.add(camera.position, 'z')
        .name('摄像头z轴')
        .min(-6).max(6).step(0.02);
        return gui;
  }